/**
 * Google Search 아이콘 SVG
 *
 * 크기 조절: className으로 w-*, h-* 클래스 사용
 * @example
 * ```tsx
 * <GoogleSearchIcon className="w-8 h-8" />
 * <GoogleSearchIcon className="w-12 h-12" />
 * ```
 */
export function GoogleSearchIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-label="Google Search icon"
      role="img"
    >
      <title>Google Search</title>
      <g id="Google Searc">
        <g id="Vector">
          <path
            d="M29.7277 13.2581H28.6V13.2H16V18.8H23.9121C22.7578 22.0599 19.6561 24.4 16 24.4C11.3611 24.4 7.6 20.6389 7.6 16C7.6 11.3611 11.3611 7.6 16 7.6C18.1413 7.6 20.0894 8.4078 21.5727 9.7273L25.5326 5.7674C23.0322 3.4371 19.6876 2 16 2C8.2685 2 2 8.2685 2 16C2 23.7315 8.2685 30 16 30C23.7315 30 30 23.7315 30 16C30 15.0613 29.9034 14.145 29.7277 13.2581Z"
            fill="#FBC02D"
          />
          <path
            d="M3.6142 9.4837L8.2139 12.857C9.4585 9.7756 12.4727 7.6 16 7.6C18.1413 7.6 20.0894 8.4078 21.5727 9.7273L25.5326 5.7674C23.0322 3.4371 19.6876 2 16 2C10.6226 2 5.9592 5.0359 3.6142 9.4837Z"
            fill="#E53935"
          />
          <path
            d="M16 30C19.6162 30 22.902 28.6161 25.3863 26.3656L21.0533 22.699C19.6477 23.7637 17.9005 24.4 16 24.4C12.3586 24.4 9.2667 22.0781 8.1019 18.8378L3.5365 22.3553C5.8535 26.8892 10.5589 30 16 30Z"
            fill="#4CAF50"
          />
          <path
            d="M29.7277 13.2581L29.7165 13.2H28.6H16V18.8H23.9121C23.3577 20.3659 22.3504 21.7162 21.0512 22.6997L21.0533 22.699L25.3863 26.3656C25.0797 26.6442 30 23 30 16C30 15.0613 29.9034 14.145 29.7277 13.2581Z"
            fill="#1565C0"
          />
        </g>
      </g>
    </svg>
  );
}
